import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { DataProvider } from './contexts/DataContext';
import EnhancedErrorBoundary, { withErrorBoundary } from './components/common/EnhancedErrorBoundary';
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import BlogPage from './pages/BlogPage';
import ContactPage from './pages/ContactPage';
import ProfessionPage from './pages/ProfessionPage';
import EditorPage from './pages/EditorPage';
import TemplatesGallery from './pages/TemplatesGallery';
import BlogDetailPage from './pages/BlogDetailPage';
import NotFound from './pages/NotFound';
import './styles/base.css';
import './styles/components.css';
import './styles/home.css';
import './styles/static-pages.css';
import './styles/templates-gallery.css';
import './styles/editor.css';
import './styles/Toolbar.css';
import './styles/editor-enhanced.css';
import PrivacyPage from './pages/PrivacyPage';

// Wrap pages with error boundaries
const HomePageWithErrorBoundary = withErrorBoundary(HomePage, { 
  componentName: 'HomePage',
  errorMessage: 'Failed to load home page. Please try again.' 
});

const AboutPageWithErrorBoundary = withErrorBoundary(AboutPage, { 
  componentName: 'AboutPage' 
});

const BlogPageWithErrorBoundary = withErrorBoundary(BlogPage, { 
  componentName: 'BlogPage' 
});

const ContactPageWithErrorBoundary = withErrorBoundary(ContactPage, { 
  componentName: 'ContactPage' 
});

const ProfessionPageWithErrorBoundary = withErrorBoundary(ProfessionPage, { 
  componentName: 'ProfessionPage' 
});

const EditorPageWithErrorBoundary = withErrorBoundary(EditorPage, { 
  componentName: 'EditorPage',
  errorMessage: 'The editor encountered an error. Please refresh the page.'
});

const TemplatesGalleryWithErrorBoundary = withErrorBoundary(TemplatesGallery, { 
  componentName: 'TemplatesGallery' 
});

const BlogDetailPageWithErrorBoundary = withErrorBoundary(BlogDetailPage, { 
  componentName: 'BlogDetailPage' 
});

function App() {
  return (
    <EnhancedErrorBoundary componentName="App">
      <HelmetProvider>
        <DataProvider>
          <BrowserRouter>
            <div className="app">
              <EnhancedErrorBoundary componentName="Navbar">
                <Navbar />
              </EnhancedErrorBoundary>
              <main>
                <Routes>
                  <Route path="/" element={<HomePageWithErrorBoundary />} />
                  <Route path="/about" element={<AboutPageWithErrorBoundary />} />
                  <Route path="/blog" element={<BlogPageWithErrorBoundary />} />
                  <Route path="/blog/:slug" element={<BlogDetailPageWithErrorBoundary />} />
                  <Route path="/contact" element={<ContactPageWithErrorBoundary />} />
                  <Route path="/profession" element={<ProfessionPageWithErrorBoundary />} />
                  <Route path="/editor" element={<EditorPageWithErrorBoundary />} />
                  <Route path="/editor/:templateId" element={<EditorPageWithErrorBoundary />} />
                  <Route path="/templates" element={<TemplatesGalleryWithErrorBoundary />} />
                  <Route path="*" element={<NotFound />} />
                  <Route path="/privacy-policy" element={<PrivacyPage />} />
                </Routes>
              </main>
              <EnhancedErrorBoundary componentName="Footer">
                <Footer />
              </EnhancedErrorBoundary>
            </div>
          </BrowserRouter>
        </DataProvider>
      </HelmetProvider>
    </EnhancedErrorBoundary>
  );
}

export default App;